import Dialog from '@mui/material/Dialog';
import { useEffect, useState } from 'react';

function NRDialog({ isOpen, setIsOpen, children, scroll = 'paper', maxWidth = 'xs', fullWidth = false, ariaLabelledBy, ariaDescribedBy }) {
  const [open, setOpen] = useState(false);
  const handleClose = (e, reason) => {
    if (reason && reason == 'backdropClick') return;
    setIsOpen(false);
    setOpen(false);
  };

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  return (
    <Dialog
      aria-labelledby={ariaLabelledBy || 'nr-dialog-title'}
      aria-describedby={ariaDescribedBy}
      open={open}
      onClose={handleClose}
      fullWidth={fullWidth}
      scroll={scroll}
      maxWidth={maxWidth}
      BackdropProps={{
        timeout: 500
      }}
      PaperProps={{ elevation: 0 }}
      disableEnforceFocus={true}
      disableRestoreFocus={true}
      disableAutoFocus
      disablePortal={true}
    >
      {children}
    </Dialog>
  );
}

export default NRDialog;
